import $ from 'jquery'
import { isMobile } from 'mobile-device-detect'

const showMobileModeDirective = function(Vue) {
    Vue.directive('show-mobile-mode', {
        bind: function(el, binding, vnode) {
            let expr = binding.value
        
            let $el = $(el)

            let hopeIsMobile =
                expr.value == true ||
                expr.value == 'true'

            if (hopeIsMobile && isMobile == false) {
                $el.remove()
            }
        }
    })
}

export { showMobileModeDirective }


// WEBPACK FOOTER //
// ./src/directives/show-mobile-mode-directive.js